(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-better-view"] && !Shopify.designMode) return;
  try {
    
  function kvEqualizeBetterViewPoints(root) {
    var views = [];
    var scope = root || document;

    if (scope.matches && scope.matches('[data-kv-better-view]')) {
      views.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-kv-better-view]').forEach(function (view) {
        if (views.indexOf(view) === -1) views.push(view);
      });
    }

    views.forEach(function (view) {
      var lists = view.querySelectorAll('.kv-better-view-points');
      var rows = [];

      lists.forEach(function (list) {
        var points = list.querySelectorAll('.kv-better-view-point');
        points.forEach(function (point, index) {
          point.style.removeProperty('--kv-better-view-point-height');
          if (!rows[index]) rows[index] = [];
          rows[index].push(point);
        });
      });

      rows.forEach(function (group) {
        if (group.length < 2) return;

        var maxHeight = 0;
        group.forEach(function (point) {
          maxHeight = Math.max(maxHeight, point.offsetHeight);
        });

        group.forEach(function (point) {
          point.style.setProperty('--kv-better-view-point-height', maxHeight + 'px');
        });
      });
    });
  }

  function kvInitBetterViewPoints(root) {
    kvEqualizeBetterViewPoints(root);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        kvEqualizeBetterViewPoints(root);
      });
    }
  }

  var kvBetterViewResizeTimer;

  function kvOnBetterViewResize() {
    window.clearTimeout(kvBetterViewResizeTimer);
    kvBetterViewResizeTimer = window.setTimeout(function () {
      kvEqualizeBetterViewPoints();
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      kvInitBetterViewPoints();
    });
  } else {
    kvInitBetterViewPoints();
  }

  window.addEventListener('resize', kvOnBetterViewResize);

  document.addEventListener('shopify:section:load', function (event) {
    kvInitBetterViewPoints(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    kvEqualizeBetterViewPoints(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-collection-hero-ss-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ATTR_ROOT = 'data-kv-col-hero-ss';
  var ATTR_INIT = 'kvColHeroSsInit';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initRoot(root) {
    if (!root || root.dataset[ATTR_INIT] === 'true') return;

    var track = root.querySelector('[data-kv-col-hero-ss-track]');
    var slides = toArray(root.querySelectorAll('[data-kv-col-hero-ss-slide]'));
    var dots = toArray(root.querySelectorAll('[data-kv-col-hero-ss-dot]'));
    if (!track || !slides.length) return;

    root.dataset[ATTR_INIT] = 'true';

    var index = 0;
    var delay = parseInt(root.getAttribute('data-kv-col-hero-ss-autoplay') || '0', 10);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canDrag = slides.length > 1;
    var looping = canDrag;
    var dragging = false;
    var locked = false;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var startTime = 0;
    var dragOffset = 0;
    var lockClick = false;
    var pointerId = null;

    if (root._kvColHeroTimer) {
      clearInterval(root._kvColHeroTimer);
      root._kvColHeroTimer = null;
    }

    if (looping && !track.querySelector('.kv-col-hero-ss-slide-clone')) {
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone.removeAttribute('data-kv-col-hero-ss-slide');
      lastClone.removeAttribute('data-kv-col-hero-ss-slide');
      firstClone.classList.remove('kv-col-hero-ss-slide-active');
      lastClone.classList.remove('kv-col-hero-ss-slide-active');
      firstClone.classList.add('kv-col-hero-ss-slide-clone');
      lastClone.classList.add('kv-col-hero-ss-slide-clone');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);
    }

    if (canDrag) {
      root.classList.add('kv-col-hero-ss-draggable');
    }

    function slideWidth() {
      return root.getBoundingClientRect().width || root.offsetWidth || 1;
    }

    function trackX(forIndex, extra) {
      var pos = looping ? forIndex + 1 : forIndex;
      return -(pos * slideWidth()) + (extra || 0);
    }

    function setTrackX(x, animate) {
      track.classList.toggle('kv-col-hero-ss-track-dragging', !animate);
      if (reduceMotion) {
        track.style.transitionDuration = animate ? '0.01s' : '0s';
      } else {
        track.style.transitionDuration = animate ? '' : '0s';
      }
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function updateUi() {
      slides.forEach(function (slide, i) {
        var isActive = i === index;
        slide.classList.toggle('kv-col-hero-ss-slide-active', isActive);
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('kv-col-hero-ss-dot-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function normalizeIndex(nextIndex) {
      var len = slides.length;
      return ((nextIndex % len) + len) % len;
    }

    function goTo(nextIndex, animate) {
      if (!canDrag) return;
      var target = nextIndex;
      if (looping) {
        if (target < 0 || target >= slides.length) {
          setTrackX(trackX(target, 0), animate !== false);
          index = normalizeIndex(target);
          updateUi();
          window.setTimeout(function () {
            setTrackX(trackX(index, 0), false);
          }, reduceMotion ? 20 : 460);
          return;
        }
      }
      index = normalizeIndex(target);
      setTrackX(trackX(index, 0), animate !== false);
      updateUi();
    }

    function stopTimer() {
      if (root._kvColHeroTimer) {
        clearInterval(root._kvColHeroTimer);
        root._kvColHeroTimer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (dragging || reduceMotion || !delay || delay < 1 || !canDrag) return;
      root._kvColHeroTimer = setInterval(function () {
        goTo(index + 1, true);
      }, delay);
    }

    function onPointerDown(event) {
      if (!canDrag || event.button) return;
      if (event.target.closest('[data-kv-col-hero-ss-dots]')) return;
      dragging = false;
      locked = false;
      lockClick = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      startTime = Date.now();
      dragOffset = 0;
      stopTimer();
      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    }

    function onPointerMove(event) {
      if (pointerId !== event.pointerId) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (!locked) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          unbindPointer();
          startTimer();
          return;
        }
        locked = true;
        dragging = true;
        root.classList.add('kv-col-hero-ss-grabbing');
        try {
          track.setPointerCapture(event.pointerId);
        } catch (err) {}
      }

      if (event.cancelable) event.preventDefault();
      lastX = event.clientX;
      dragOffset = dx;
      setTrackX(trackX(index, dragOffset), false);
    }

    function unbindPointer() {
      pointerId = null;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }

    function onPointerUp(event) {
      if (pointerId !== event.pointerId) return;
      unbindPointer();
      root.classList.remove('kv-col-hero-ss-grabbing');

      if (!locked) {
        dragging = false;
        startTimer();
        return;
      }

      var dx = event.clientX - startX;
      var dt = Math.max(Date.now() - startTime, 1);
      var velocity = dx / dt;
      var width = slideWidth();
      var threshold = Math.max(50, width * 0.18);
      var next = index;

      if (dx < -threshold || velocity < -0.35) {
        next = index + 1;
      } else if (dx > threshold || velocity > 0.35) {
        next = index - 1;
      }

      if (Math.abs(dx) > 8) lockClick = true;
      dragging = false;
      locked = false;
      goTo(next, true);
      startTimer();
    }

    function onClickCapture(event) {
      if (!lockClick) return;
      event.preventDefault();
      event.stopPropagation();
      lockClick = false;
    }

    function onResize() {
      setTrackX(trackX(index, 0), false);
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('click', onClickCapture, true);
    window.addEventListener('resize', onResize);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i, true);
        startTimer();
      });
    });

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', function () {
      if (!dragging) startTimer();
    });
    root.addEventListener('focusin', stopTimer);
    root.addEventListener('focusout', startTimer);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else if (!dragging) {
        startTimer();
      }
    });

    root._kvColHeroCleanup = function () {
      stopTimer();
      unbindPointer();
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('click', onClickCapture, true);
      window.removeEventListener('resize', onResize);
    };

    setTrackX(trackX(index, 0), false);
    updateUi();
    startTimer();
  }

  function initAll() {
    toArray(document.querySelectorAll('[' + ATTR_ROOT + ']')).forEach(function (root) {
      if (root.dataset[ATTR_INIT] === 'true') return;
      initRoot(root);
    });
  }

  function onSectionLoad(event) {
    if (!event || !event.target) return;
    var root = event.target.hasAttribute(ATTR_ROOT)
      ? event.target
      : event.target.querySelector('[' + ATTR_ROOT + ']');
    if (!root) return;
    root.dataset[ATTR_INIT] = '';
    initRoot(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    var root = event.target.hasAttribute(ATTR_ROOT)
      ? event.target
      : event.target.querySelector('[' + ATTR_ROOT + ']');
    if (!root) return;
    if (root._kvColHeroCleanup) root._kvColHeroCleanup();
    if (root._kvColHeroTimer) {
      clearInterval(root._kvColHeroTimer);
      root._kvColHeroTimer = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-essentials-within-reach"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadSwiperAssets() {
    return new Promise(function (resolve, reject) {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }

      if (!document.querySelector('link[data-kv-essentials-swiper-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        link.setAttribute('data-kv-essentials-swiper-css', '');
        document.head.appendChild(link);
      }

      var existing = document.querySelector('script[data-kv-essentials-swiper-js]');
      if (existing) {
        if (window.Swiper) {
          resolve(window.Swiper);
          return;
        }
        existing.addEventListener('load', function () {
          resolve(window.Swiper);
        });
        existing.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.defer = true;
      script.setAttribute('data-kv-essentials-swiper-js', '');
      script.onload = function () {
        resolve(window.Swiper);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initKvEssentials(root) {
    if (!root || root.dataset.kvEssentialsInit === 'true') return;
    var swiperEl = root.querySelector('[data-kv-essentials-swiper]');
    if (!swiperEl) return;

    root.dataset.kvEssentialsInit = 'true';

    var blockCount = parseInt(root.getAttribute('data-block-count') || '0', 10);
    var prevEl = root.querySelector('[data-kv-essentials-prev]');
    var nextEl = root.querySelector('[data-kv-essentials-next]');
    var paginationEl = root.querySelector('[data-kv-essentials-pagination]');
    var enableControls = blockCount > 1;

    loadSwiperAssets()
      .then(function (Swiper) {
        if (!Swiper) return;

        new Swiper(swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 12,
          watchOverflow: false,
          observer: true,
          observeParents: true,
          pagination: enableControls && paginationEl
            ? {
                el: paginationEl,
                clickable: true
              }
            : undefined,
          navigation: enableControls && prevEl && nextEl
            ? {
                prevEl: prevEl,
                nextEl: nextEl
              }
            : undefined,
          breakpoints: {
            750: {
              slidesPerView: 2.5,
              spaceBetween: 12
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 12
            }
          }
        });
      })
      .catch(function () {
        /* Swiper failed to load */
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kv-essentials]').forEach(initKvEssentials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target;
    if (!sectionRoot) return;
    sectionRoot.querySelectorAll('[data-kv-essentials]').forEach(function (el) {
      el.dataset.kvEssentialsInit = '';
    });
    initAll(sectionRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-keynote-section"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      var loadPromise = null;
  
      function loadSwiper() {
        if (window.Swiper) return Promise.resolve(window.Swiper);
        if (loadPromise) return loadPromise;
  
        loadPromise = new Promise(function (resolve, reject) {
          var existing = document.querySelector('script[data-kv-swiper-lib]');
          if (existing) {
            existing.addEventListener('load', function () {
              resolve(window.Swiper);
            });
            existing.addEventListener('error', reject);
            if (window.Swiper) resolve(window.Swiper);
            return;
          }
  
          var script = document.createElement('script');
          script.src = SWIPER_SRC;
          script.async = true;
          script.dataset.kvSwiperLib = 'true';
          script.onload = function () {
            resolve(window.Swiper);
          };
          script.onerror = reject;
          document.head.appendChild(script);
        });
  
        return loadPromise;
      }
  
      function destroySwiper(sectionEl) {
        var swiperEl = sectionEl.querySelector('[data-kv-keynote-swiper]');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
        delete sectionEl.dataset.kvSwiperReady;
      }
  
      function initKeynoteSwipers(root) {
        var scope = root || document;
  
        scope.querySelectorAll('[data-kv-keynote]').forEach(function (sectionEl) {
          if (sectionEl.getAttribute('data-kv-swiper') !== 'true') return;
          if (sectionEl.dataset.kvSwiperReady === 'true') return;
  
          var swiperEl = sectionEl.querySelector('[data-kv-keynote-swiper]');
          var paginationEl = sectionEl.querySelector('[data-kv-keynote-pagination]');
          if (!swiperEl || !paginationEl) return;
  
          sectionEl.dataset.kvSwiperReady = 'true';
  
          loadSwiper().then(function (Swiper) {
            if (!Swiper || !sectionEl.isConnected) return;
            if (swiperEl.swiper) return;
  
            new Swiper(swiperEl, {
              slidesPerView: 1.15,
              spaceBetween: 10,
              grabCursor: true,
              watchOverflow: true,
              observer: true,
              observeParents: true,
              pagination: {
                el: paginationEl,
                clickable: true,
                bulletClass: 'kv-keynote__bullet',
                bulletActiveClass: 'is-active',
              },
            });
          });
        });
      }
  
      function syncSoundButton(video, button) {
        if (!button) return;
        var muted = !!video.muted || video.volume === 0;
        button.classList.toggle('is-muted', muted);
        button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      function syncPlaybackButton(video, button) {
        if (!button) return;
        var paused = !!video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }

      function playVideo(video) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          return playPromise.catch(function () {});
        }
        return playPromise;
      }

      function tryUnmute(video, soundButton) {
        video.removeAttribute('muted');
        video.muted = false;
        video.volume = 1;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            video.muted = true;
            video.setAttribute('muted', '');
            playVideo(video);
            syncSoundButton(video, soundButton);
          });
        }
        syncSoundButton(video, soundButton);
      }

      function initKeynoteVideos(root) {
        var scope = root || document;

        scope.querySelectorAll('[data-kv-keynote-video]').forEach(function (video) {
          if (video.dataset.kvSoundReady === 'true') return;
          video.dataset.kvSoundReady = 'true';

          var media = video.closest('.kv-keynote__media');
          var soundButton = media ? media.querySelector('[data-kv-keynote-sound]') : null;
          var playbackButton = media ? media.querySelector('[data-kv-keynote-playback]') : null;
          var userPaused = false;

          video.loop = true;
          video.playsInline = true;
          video.muted = true;
          video.setAttribute('muted', '');
          syncSoundButton(video, soundButton);
          syncPlaybackButton(video, playbackButton);

          video.addEventListener('volumechange', function () {
            syncSoundButton(video, soundButton);
          });

          video.addEventListener('play', function () {
            syncPlaybackButton(video, playbackButton);
          });

          video.addEventListener('pause', function () {
            syncPlaybackButton(video, playbackButton);
          });

          if (soundButton) {
            soundButton.addEventListener('click', function () {
              if (video.muted || video.volume === 0) {
                tryUnmute(video, soundButton);
              } else {
                video.muted = true;
                syncSoundButton(video, soundButton);
              }
            });
          }

          if (playbackButton) {
            playbackButton.addEventListener('click', function () {
              if (video.paused) {
                userPaused = false;
                playVideo(video);
              } else {
                userPaused = true;
                video.pause();
              }
              syncPlaybackButton(video, playbackButton);
            });
          }

          var startPlayback = function () {
            if (userPaused) return;
            video.muted = true;
            var playPromise = video.play();
            if (!playPromise || typeof playPromise.then !== 'function') {
              tryUnmute(video, soundButton);
              return;
            }
            playPromise
              .then(function () {
                tryUnmute(video, soundButton);
              })
              .catch(function () {
                video.muted = true;
                playVideo(video);
                syncSoundButton(video, soundButton);
              });
          };

          if (video.readyState >= 2) {
            startPlayback();
          } else {
            video.addEventListener('canplay', startPlayback, { once: true });
          }
        });
      }
  
      function boot() {
        initKeynoteVideos();
        initKeynoteSwipers();
      }
  
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
  
      document.addEventListener('shopify:section:load', function (event) {
        var sectionRoot = event.target;
        if (!sectionRoot || !sectionRoot.querySelectorAll) return;
        sectionRoot.querySelectorAll('[data-kv-keynote]').forEach(destroySwiper);
        initKeynoteVideos(sectionRoot);
        initKeynoteSwipers(sectionRoot);
      });
  
      document.addEventListener('shopify:section:unload', function (event) {
        var sectionRoot = event.target;
        if (!sectionRoot || !sectionRoot.querySelectorAll) return;
        sectionRoot.querySelectorAll('[data-kv-keynote]').forEach(destroySwiper);
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
